import React, { useEffect, useState } from 'react';
import { signOut } from 'aws-amplify/auth';
import '../styles/common.css';

const adminEmails = ['age-system@nouv.co.jp'];

const AdminDashboard = ({user, onSignOut}) => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [allData, setAllData] = useState([]);
  const [unsentSortKey, setUnsentSortKey] = useState('');
  const [unsentSortOrder, setUnsentSortOrder] = useState('asc');
  const [allSortKey, setAllSortKey] = useState('');
  const [allSortOrder, setAllSortOrder] = useState('asc');
  const [searchKey, setSearchKey] = useState('');
  const [searchField, setSearchField] = useState('B2_CustomerCompany');

  useEffect(() => {
    const fetchData = async () => {
      const res = await fetch('https://43f7djf5c3.execute-api.ap-northeast-1.amazonaws.com/AdminTableStage/get_all_license');
      const data = await res.json();
      setAllData(data.Items || data);
    };

    const now = Date.now();
    const loginTimeKey = 'loginTime';
    const twentyFourHours = 7 * 24 * 60 * 60 * 1000;

    const stored = localStorage.getItem(loginTimeKey);

    if (!stored) {
      localStorage.setItem(loginTimeKey, now.toString());
    } else {
      const elapsed = now - parseInt(stored, 10);
      if (elapsed > twentyFourHours) {
        signOut().then(() => {
          alert('セッションが途切れたため、再ログインしてください。');
          localStorage.removeItem(loginTimeKey);
          window.location.href = '/license';
        });
        return;
      }
    }

    const timeout = setTimeout(async () => {
      await signOut();
      localStorage.removeItem(loginTimeKey);
      alert('セッションが途切れたため、再度ログインしてください。');
      window.location.href = '/license';
    }, twentyFourHours);

    fetchData();

    const loginEmail = user?.signInDetails?.loginId;
    if (adminEmails.includes(loginEmail)) {
      setIsAdmin(true);
    }

    return () => clearTimeout(timeout);
  }, [user]);


  const handleUnsentSort = (key) => {
    if (unsentSortKey === key) {
      setUnsentSortOrder(unsentSortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      setUnsentSortKey(key);
      setUnsentSortOrder('asc');
    }
  };

  const handleAllSort = (key) => {
    if (allSortKey === key) {
      setAllSortOrder(allSortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      setAllSortKey(key);
      setAllSortOrder('asc');
    }
  };

  const getSortedData = (data, key, order) => {
    return [...data].sort((a, b) => {
      let valA, valB;

      if (key.startsWith('history-')) {
        const index = parseInt(key.split('-')[1], 10);
        valA = a.A5_AuthHistory?.[index]?.Timestamp || '';
        valB = b.A5_AuthHistory?.[index]?.Timestamp || '';
      } else {
        valA = a[key] || '';
        valB = b[key] || '';
      }

      if (valA < valB) return order === 'asc' ? -1 : 1;
      if (valA > valB) return order === 'asc' ? 1 : -1;
      return 0;
    });
  };

  const unsent = getSortedData(allData.filter(d => d.D1_SendMail !== "済"), unsentSortKey, unsentSortOrder);

  const filteredData = getSortedData(
    allData.filter(d =>
    (searchKey === '' || (d[searchField] || '').toString().includes(searchKey))
    ),
    allSortKey,
    allSortOrder
  );


  const renderUnsentArrow = (key) => {
    if (unsentSortKey !== key) return '';
    return unsentSortOrder === 'asc' ? ' ▲' : ' ▼';
  };

  const renderAllArrow = (key) => {
    if (allSortKey !== key) return '';
    return allSortOrder === 'asc' ? ' ▲' : ' ▼';
  };


  const handleSendMail = async (item) => {
    try {
      const res = await fetch("https://i9i8zfsoai.execute-api.ap-northeast-1.amazonaws.com/DeliveryStage/send_mail", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(item),
      });

      const data = await res.json();
      if (data.message === "success") {
        alert("納品メールを送信しました！");
        window.location.reload();
      } else {
        alert("送信に失敗しました：" + data.error);
      }
    } catch (err) {
      console.error("送信エラー:", err);
      alert("サーバーエラーが発生しました");
    }
  };


  const maxHistoryCount = allData && allData.length > 0
  ? Math.max(...allData.map(item => item.A5_AuthHistory?.length || 0))
  : 0;


  return (
    <div className="container-list">
      <button className="button button-blue" onClick={() => {
        localStorage.removeItem('loginTime');
        onSignOut();
      }}>ログアウト</button>

      <div className="fixed-title-wrapper">
        <div className="header"></div>
        <h1 className="title-admin">取引一覧</h1>
      </div>

      <div className="scroll-wrapper">
        {isAdmin && (
          <>
            <h2 style={{ marginLeft: '5px', marginBottom: '15px', fontSize: '1.5em' }}>未処理一覧</h2>
            <table className="table unsent">
              <thead><tr className="table-header-red">
                <th>ボタン</th>
                <th onClick={() => handleUnsentSort('D1_SendMail')}>状態{renderUnsentArrow('D1_SendMail')}</th>
                <th onClick={() => handleUnsentSort('D4_EditContents')}>更新{renderUnsentArrow('D4_EditContents')}</th>
                <th onClick={() => handleUnsentSort('A1_ProductName')}>製品名{renderUnsentArrow('A1_ProductName')}</th>
                <th onClick={() => handleUnsentSort('A2_LicenseCount')}>個数{renderUnsentArrow('A2_LicenseCount')}</th>
                <th onClick={() => handleUnsentSort('D5_UpdateVersion')}>ver.{renderUnsentArrow('D5_UpdateVersion')}</th>
                <th onClick={() => handleUnsentSort('D3_Trial')}>プラン{renderUnsentArrow('D3_Trial')}</th>
                <th onClick={() => handleUnsentSort('A3_LicenseStartDate')}>開始日{renderUnsentArrow('A3_LicenseStartDate')}</th>
                <th onClick={() => handleUnsentSort('A4_LicenseEndDate')}>終了日{renderUnsentArrow('A4_LicenseEndDate')}</th>
                <th onClick={() => handleUnsentSort('CustomerEmail')}>ライセンスアドレス{renderUnsentArrow('CustomerEmail')}</th>
                <th onClick={() => handleUnsentSort('LicenseKey')}>ライセンスキー{renderUnsentArrow('LicenseKey')}</th>
                <th onClick={() => handleUnsentSort('B1_CustomerType')}>形態{renderUnsentArrow('B1_CustomerType')}</th>
                <th onClick={() => handleUnsentSort('B2_CustomerCompany')}>エンドユーザー会社名{renderUnsentArrow('B2_CustomerCompany')}</th>
                <th onClick={() => handleUnsentSort('B3_CustomerPerson')}>エンドユーザー担当者名{renderUnsentArrow('B3_CustomerPerson')}</th>
                <th onClick={() => handleUnsentSort('B4_CustomerEmail')}>エンドユーザー担当者メール{renderUnsentArrow('B4_CustomerEmail')}</th>
                <th onClick={() => handleUnsentSort('C1_OrderCompany')}>発注会社名{renderUnsentArrow('C1_OrderCompany')}</th>
                <th onClick={() => handleUnsentSort('C2_OrderPerson')}>発注者名{renderUnsentArrow('C2_OrderPerson')}</th>
                <th onClick={() => handleUnsentSort('C3_OrderEmail')}>発注者メール{renderUnsentArrow('C3_OrderEmail')}</th>
                <th onClick={() => handleUnsentSort('C4_OrderNumber')}>弊社見積No.{renderUnsentArrow('C4_OrderNumber')}</th>
                <th onClick={() => handleUnsentSort('C6_OrderID')}>発注番号{renderUnsentArrow('C6_OrderID')}</th>
                <th onClick={() => handleUnsentSort('D2_RegisterDate')}>登録日{renderUnsentArrow('D2_RegisterDate')}</th>

                {Array.from({ length: maxHistoryCount }).map((_, i) => (
                  <th
                    key={`history-${i}`}
                    onClick={() => handleUnsentSort(`history-${i}`)}
                  >
                  認証履歴 {i + 1} {unsentSortKey === `history-${i}` ? (unsentSortOrder === 'asc' ? '▲' : '▼') : ''}
                  </th>
                ))}

              </tr></thead>
              <tbody>
                {unsent.map((item, idx) => (
                  <tr key={idx}>
                    <td><button onClick={() => handleSendMail(item)}>送信</button></td>
                    <td>{item.D1_SendMail}</td>
                    <td>{item.D4_EditContents?.length > 0 ? item.D4_EditContents.join(', ') : ''}</td>
                    <td>{item.A1_ProductName}</td>
                    <td>{item.A2_LicenseCount}</td>
                    <td>{item.D5_UpdateVersion}</td>
                    <td>{item.D3_Trial}</td>
                    <td>{item.A3_LicenseStartDate}</td>
                    <td>{item.A4_LicenseEndDate}</td>
                    <td>{item.CustomerEmail}</td>
                    <td>{item.LicenseKey}</td>
                    <td>{item.B1_CustomerType}</td>
                    <td>{item.B2_CustomerCompany}</td>
                    <td>{item.B3_CustomerPerson}</td>
                    <td>{item.B4_CustomerEmail}</td>
                    <td>{item.C1_OrderCompany}</td>
                    <td>{item.C2_OrderPerson}</td>
                    <td>{item.C3_OrderEmail}</td>
                    <td>{item.C4_OrderNumber}</td>
                    <td>{item.C6_OrderID}</td>
                    <td>{item.D2_RegisterDate}</td>
                    {Array.from({ length: maxHistoryCount }).map((_, i) => {
                      const history = item.A5_AuthHistory?.[i];
                      return (
                        <td key={`history-${idx}-${i}`}>
                          {history ? `${history.Timestamp} (${history.UserName})` : '-'}
                        </td>
                      );
                    })}

                  </tr>
                ))}
              </tbody>
            </table>
          </>
        )}

        <div
          style={{
            marginTop: isAdmin ? '0px' : '15px'
          }}
        >

          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
              gap: '2em',
              marginBottom: '1em'
            }}
          >
            <h2 style={{ marginLeft: '5px', marginBottom: '3px', fontSize: '1.5em' }}>全件一覧</h2>

            <div
              className="search-bar"
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                fontSize: '90%',
                marginTop: '14px',
              }}
            >
              <select
                value={searchField}
                onChange={(e) => setSearchField(e.target.value)}
                style={{ height: '24px', fontSize: '90%' }}
              >
                <option value="D1_SendMail">状態</option>
                <option value="D3_Trial">プラン</option>
                <option value="B1_CustomerType">形態</option>
                <option value="B2_CustomerCompany">エンドユーザー会社名</option>
                <option value="B3_CustomerPerson">エンドユーザー担当者名</option>
                <option value="B4_CustomerEmail">エンドユーザー担当者メール</option>
                <option value="A1_ProductName">製品名</option>
                <option value="A2_LicenseCount">個数</option>
                <option value="D5_UpdateVersion">ver.</option>
                <option value="A3_LicenseStartDate">開始日</option>
                <option value="A4_LicenseEndDate">終了日</option>
                <option value="CustomerEmail">ライセンスアドレス</option>
                <option value="LicenseKey">ライセンスキー</option>
                <option value="C2_OrderPerson">発注者名</option>
                <option value="C4_OrderNumber">弊社見積No.</option>
                <option value="C6_OrderID">発注番号</option>
                <option value="D2_RegisterDate">登録日</option>
              </select>

              <input
                type="text"
                placeholder="検索キーワード"
                value={searchKey}
                onChange={(e) => setSearchKey(e.target.value)}
                style={{ fontSize: '90%', height: '24px' }}
              />

              <span style={{ fontSize: '90%' }}>
                {searchKey ? `${filteredData.length} 件一致` : `${filteredData.length} 件全件表示`}
              </span>
            </div>
          </div>

          <table className="table all">
            <thead><tr className="table-header-blue">
              <th onClick={() => handleAllSort('D1_SendMail')}>状態{renderAllArrow('D1_SendMail')}</th>
              <th onClick={() => handleAllSort('A1_ProductName')}>製品名{renderAllArrow('A1_ProductName')}</th>
              <th onClick={() => handleAllSort('A2_LicenseCount')}>個数{renderAllArrow('A2_LicenseCount')}</th>
              <th onClick={() => handleAllSort('D5_UpdateVersion')}>ver.{renderAllArrow('D5_UpdateVersion')}</th>
              <th onClick={() => handleAllSort('D3_Trial')}>プラン{renderAllArrow('D3_Trial')}</th>
              <th onClick={() => handleAllSort('A3_LicenseStartDate')}>開始日{renderAllArrow('A3_LicenseStartDate')}</th>
              <th onClick={() => handleAllSort('A4_LicenseEndDate')}>終了日{renderAllArrow('A4_LicenseEndDate')}</th>
              <th onClick={() => handleAllSort('CustomerEmail')}>ライセンスアドレス{renderAllArrow('CustomerEmail')}</th>
              <th onClick={() => handleAllSort('LicenseKey')}>ライセンスキー{renderAllArrow('LicenseKey')}</th>
              <th onClick={() => handleAllSort('B1_CustomerType')}>形態{renderAllArrow('B1_CustomerType')}</th>
              <th onClick={() => handleAllSort('B2_CustomerCompany')}>エンドユーザー会社名{renderAllArrow('B2_CustomerCompany')}</th>
              <th onClick={() => handleAllSort('B3_CustomerPerson')}>エンドユーザー担当者名{renderAllArrow('B3_CustomerPerson')}</th>
              <th onClick={() => handleAllSort('B4_CustomerEmail')}>エンドユーザー担当者メール{renderAllArrow('B4_CustomerEmail')}</th>
              <th onClick={() => handleAllSort('C1_OrderCompany')}>発注会社名{renderAllArrow('C1_OrderCompany')}</th>
              <th onClick={() => handleAllSort('C2_OrderPerson')}>発注者名{renderAllArrow('C2_OrderPerson')}</th>
              <th onClick={() => handleAllSort('C3_OrderEmail')}>発注者メール{renderAllArrow('C3_OrderEmail')}</th>
              <th onClick={() => handleAllSort('C4_OrderNumber')}>弊社見積No.{renderAllArrow('C4_OrderNumber')}</th>
              <th onClick={() => handleAllSort('C6_OrderID')}>発注番号{renderAllArrow('C6_OrderID')}</th>
              <th onClick={() => handleAllSort('D2_RegisterDate')}>登録日{renderAllArrow('D2_RegisterDate')}</th>
              <th onClick={() => handleAllSort('D4_EditContents')}>更新{renderAllArrow('D4_EditContents')}</th>

              {Array.from({ length: maxHistoryCount }).map((_, i) => (
                <th
                  key={`all-header-${i}`}
                  onClick={() => handleAllSort(`history-${i}`)}
                >
                  認証履歴 {i + 1} {allSortKey === `history-${i}` ? (allSortOrder === 'asc' ? '▲' : '▼') : ''}
                </th>
              ))}

            </tr></thead>
            <tbody>
              {filteredData.map((item, idx) => (
                <tr key={idx}>
                  <td>{item.D1_SendMail}</td>
                  <td>{item.A1_ProductName}</td>
                  <td>{item.A2_LicenseCount}</td>
                  <td>{item.D5_UpdateVersion}</td>
                  <td>{item.D3_Trial}</td>
                  <td>{item.A3_LicenseStartDate}</td>
                  <td>{item.A4_LicenseEndDate}</td>
                  <td>{item.CustomerEmail}</td>
                  <td>{item.LicenseKey}</td>
                  <td>{item.B1_CustomerType}</td>
                  <td>{item.B2_CustomerCompany}</td>
                  <td>{item.B3_CustomerPerson}</td>
                  <td>{item.B4_CustomerEmail}</td>
                  <td>{item.C1_OrderCompany}</td>
                  <td>{item.C2_OrderPerson}</td>
                  <td>{item.C3_OrderEmail}</td>
                  <td>{item.C4_OrderNumber}</td>
                  <td>{item.C6_OrderID}</td>
                  <td>{item.D2_RegisterDate}</td>
                  <td>{item.D4_EditContents?.length > 0 ? item.D4_EditContents.join(', ') : ''}</td>
                  {Array.from({ length: maxHistoryCount }).map((_, i) => {
                    const history = item.A5_AuthHistory?.[i];
                    return (
                      <td key={`all-history-${idx}-${i}`}>
                        {history ? `${history.Timestamp} (${history.UserName})` : '-'}
                      </td>
                    );
                  })}

                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;

